function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.5781 0.105469H7.57812C3.43663 0.105469 0.078125 3.46397 0.078125 7.60547V16.6055C0.078125 20.747 3.43663 24.1055 7.57812 24.1055H16.5781C20.7196 24.1055 24.0781 20.747 24.0781 16.6055V7.60547C24.0781 3.46397 20.7196 0.105469 16.5781 0.105469ZM21.8281 16.6055C21.8281 19.5005 19.4731 21.8555 16.5781 21.8555H7.57812C4.68313 21.8555 2.32812 19.5005 2.32812 16.6055V7.60547C2.32812 4.71047 4.68313 2.35547 7.57812 2.35547H16.5781C19.4731 2.35547 21.8281 4.71047 21.8281 7.60547V16.6055Z",
  fill: "#09BAD3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.0781 6.10547C8.76462 6.10547 6.07812 8.79197 6.07812 12.1055C6.07812 15.419 8.76462 18.1055 12.0781 18.1055C15.3916 18.1055 18.0781 15.419 18.0781 12.1055C18.0781 8.79197 15.3916 6.10547 12.0781 6.10547ZM12.0781 15.8555C10.0111 15.8555 8.32812 14.1725 8.32812 12.1055C8.32812 10.037 10.0111 8.35547 12.0781 8.35547C14.1451 8.35547 15.8281 10.037 15.8281 12.1055C15.8281 14.1725 14.1451 15.8555 12.0781 15.8555Z",
  fill: "#09BAD3"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.528 6.45544C18.9696 6.45544 19.3275 6.0975 19.3275 5.65594C19.3275 5.21439 18.9696 4.85645 18.528 4.85645C18.0865 4.85645 17.7285 5.21439 17.7285 5.65594C17.7285 6.0975 18.0865 6.45544 18.528 6.45544Z",
  fill: "#09BAD3"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  transform: "translate(0.078125 0.105469)"
})));

var SvgInstagramIc = function SvgInstagramIc(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstagramIc, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/instagram_ic.c73147cc.svg";
export { ForwardRef as ReactComponent };